import { RegentsExemptionsListV2Module } from './regents-exemptions-list/regents-exemptions-list.module';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { SideNavNgModule } from '../../shell/side-nav/side-nav.module';
import { GraphDetailModule } from '../graph-detail/graph-detail.module';
import { GraphListModule } from '../graph-list/graph-list.module';
import { MidLevelDashModule } from './../mid-level-dashboard/mid-level-dash.module';
import { TilesModule } from './../tiles/tiles.module';
import { AcademicListV2Module } from './academic-list-v2/academic-list-v2.module';
import { AcademicListModule } from './academic-list/academic-list.module';
import { AttendanceListV2Module } from './attendance-list-v2/attendance-list-v2.module';
import { AttendanceListModule } from './attendance-list/attendance-list.module';
import { MyStudentsListModule } from './my-students-list/my-students-list.module';
import { PostsecondaryListV2Module } from './postsecondary-list-v2/postsecondary-list-v2.module';
import { PostsecondaryListModule } from './postsecondary-list/postsecondary-list.module';
import { StudentsListV2Module } from './students-list-v2/students-list-v2.module';
import { SummerSchoolListModule } from './summer-school-list/summer-school-list.module';
@NgModule({
  declarations: [],
  imports: [
    RouterModule,
    BrowserAnimationsModule,
    MyStudentsListModule,
    AttendanceListModule,
    AttendanceListV2Module,
    AcademicListModule,
    AcademicListV2Module,
    PostsecondaryListModule,
    PostsecondaryListV2Module,
    RegentsExemptionsListV2Module,
    SideNavNgModule,
    GraphDetailModule,
    GraphListModule,
    TilesModule,
    MidLevelDashModule,
    StudentsListV2Module,
    SummerSchoolListModule,
  ],
  exports: [],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SchoolListsModule {}
